module.exports = __webpack_public_path__ + "img/feedback_list4.828399e4.png";